import { FC, useEffect } from 'react';
import { useRegistrationContext } from 'context/RegistrationContext/RegistrationContext';
import { useGlobal } from 'context/global/GlobalContext';
import { useHistory } from 'react-router-dom';
import LoadingIndicator from 'components/atomic/LoadingIndicator';
import ScreenType from 'types/ScreenType';

const RegisterProductDrawer: FC<{}> = () => {
  const history = useHistory();

  const { onAuth, closePage, isMultipleRegistration, removeFormRegistration } =
    useRegistrationContext();
  const {
    slug,
    setScreen,
    registeringProduct,
    multipleRegistrationStarted,
    setMultipleRegistrationStarted,
  } = useGlobal();

  useEffect(() => {
    if (!registeringProduct && multipleRegistrationStarted) {
      setMultipleRegistrationStarted(false);
      closePage();
      isMultipleRegistration.current = false;
      history.push(`/c/${slug}`);
      setScreen(ScreenType.NONE);
    }
  }, [multipleRegistrationStarted, registeringProduct]);

  useEffect(() => {
    if (!multipleRegistrationStarted) {
      isMultipleRegistration.current = true;
      removeFormRegistration();
      onAuth(undefined, true);
    }
  }, [multipleRegistrationStarted]);

  return (
    <div className='w-full h-full flex justify-between align-between'>
      <LoadingIndicator />
    </div>
  );
};

export default RegisterProductDrawer;
